module.exports = __webpack_public_path__ + "141d4a85/img/pdf-icon.79f04a36.svg";